import React, { useEffect, useState } from 'react';
import CustomModal from '../../Modal/CustomModal';
import { InputGroup, Input } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'react-bootstrap';
import ReactSelect from 'react-select';

import "./RecurrencyEvent.css";
import { faEdit } from '@fortawesome/free-solid-svg-icons';

const RecurrenceEvent = ({ onConfirm, onClose, initialRecurrence }) => {
    const [repeatInterval, setRepeatInterval] = useState(1);
    const [repeatUnit, setRepeatUnit] = useState('day');
    const [repeatDays, setRepeatDays] = useState(new Set());
    const [repeatMonthDay, setRepeatMonthDay] = useState(1);

    useEffect(() => {
        if (!initialRecurrence) return;
    
        const stateMapping = {
            repeatInterval: setRepeatInterval,
            repeatUnit: setRepeatUnit,
            repeatDays: setRepeatDays,
            repeatMonthDay: setRepeatMonthDay
        };
    
        Object.entries(initialRecurrence).forEach(([key, value]) => {
            if (stateMapping[key]) {
                if (key === 'repeatDays') {
                    stateMapping[key](new Set(value));
                } else {
                    stateMapping[key](value);
                }
            }
        });
    }, [initialRecurrence]);
    
    const handleRepeatIntervalChange = (event) => {
        setRepeatInterval(parseInt(event.target.value));
    };

    const handleRepeatUnitChange = (selectedOption) => {
        setRepeatUnit(selectedOption.value);
    };

    const handleRepeatDayChange = (dayId) => {
        setRepeatDays(prevDays => {
            const updatedDays = new Set(prevDays);

            if (updatedDays.has(dayId)) {
                updatedDays.delete(dayId);
            } else {
                updatedDays.add(dayId);
            }

            return updatedDays;
        });
    };

    const handleRepeatMonthDayChange = (event) => {
        const input = parseInt(event.target.value);
        if ((event.target.value === '' || (input >= 1 && input <= 31))) {
            setRepeatMonthDay(input);
        } 
    };

    const renderRepeatDaysOptions = () => {
        const daysOfWeek = [
            { day: 'DOM', id: 'dom' },
            { day: 'SEG', id: 'seg' },
            { day: 'TER', id: 'ter' },
            { day: 'QUA', id: 'qua' },
            { day: 'QUI', id: 'qui' },
            { day: 'SEX', id: 'sex' },
            { day: 'SAB', id: 'sab' }
        ];

        const handleDayClick = (id) => {
            handleRepeatDayChange(id);
        };

        return (
            <div style={{ marginTop: '20px', textAlign: 'left' }} className="days-of-week">
                <div>
                    <label>Repetir nos dias:</label>
                </div>
                <div className="day-container">
                    {daysOfWeek.map((day, index) => (
                        <div key={index} className={`day ${repeatDays.has(day.id) ? 'selected-day' : ''}`} onClick={() => handleDayClick(day.id)}>
                            {day.day}
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    const renderRepeatMonthDayInput = () => {
        return (
            <div style={{ marginTop: '20px' }}>
                <label htmlFor="repeatMonthDay">Dia de Repetição: </label>
                <Input type="number" min="1" value={repeatMonthDay} max="31" onChange={handleRepeatMonthDayChange} />
            </div>
        );
    };

    const handleConfirm = () => {
        const selectedData = {
            repeatInterval,
            repeatUnit,
            repeatDays,
            repeatMonthDay
        };
        onConfirm(selectedData);
    };

    const handleClose = () => {
        onClose();
    };

    const options = [
        { value: 'day', label: 'Dia' },
        { value: 'week', label: 'Semana' },
        { value: 'month', label: 'Mês' }
    ];

    return (
        <div>
            <div className="input-group">
                <div>
                    <label htmlFor="repeatInterval">Repetir a cada: </label>
                    <Input type="number" min="1" value={repeatInterval} onChange={handleRepeatIntervalChange} />
                </div>
                <div>
                    <div style={{ marginLeft: '20px' }}>
                        <label htmlFor="repeatInterval">Frequência </label>
                        <ReactSelect
                            value={options.find(option => option.value === repeatUnit)}
                            onChange={handleRepeatUnitChange}
                            options={options}
                            isMulti={false}
                        />
                    </div>

                </div>
            </div>
            {repeatUnit === 'week' && renderRepeatDaysOptions()}
            {repeatUnit === 'month' && renderRepeatMonthDayInput()}
            <Button variant="primary" onClick={handleConfirm} style={{ float: 'right', marginTop: '20px', marginLeft: '20px' }}>Sim</Button>
            <Button variant="secondary" onClick={handleClose} style={{ float: 'right', marginTop: '20px' }}>Não</Button>
        </div>
    );
};

const formatRecurrenceData = (data) => {
    const { repeatInterval, repeatUnit, repeatDays, repeatMonthDay } = data;
    let selectedData = '';

    if (repeatUnit === 'day') {
        selectedData = `Repetir a cada ${repeatInterval} dia(s)`;
    } else if (repeatUnit === 'week') {
        if (repeatDays && repeatDays.length > 0) {
            const daysOfWeekAbbrev = repeatDays.map(day => {
                switch (day) {
                    case 'dom':
                        return 'DOM';
                    case 'seg':
                        return 'SEG';
                    case 'ter':
                        return 'TER';
                    case 'qua':
                        return 'QUA';
                    case 'qui':
                        return 'QUI';
                    case 'sex':
                        return 'SEX';
                    case 'sab':
                        return 'SÁB';
                    default:
                        return '';
                }
            });
            selectedData = `Repetir a cada ${repeatInterval} semana(s) - ${daysOfWeekAbbrev.join(', ')}`;
        } else {
            selectedData = 'Nenhum dia selecionado para repetição semanal';
        }
    } else if (repeatUnit === 'month') {
        selectedData = `Repetir a cada ${repeatInterval} mês - Dia ${repeatMonthDay}`;
    }

    return selectedData;
};


const RecurrenceInput = ({ label, required, error, onChange, value }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [recurrenceData, setRecurrenceData] = useState('');
    const [recurrenceInitial, setRecurrenceInitial] = useState();

    useEffect(() => {
        if (value) {
            const formattedData = formatRecurrenceData(value);
            setRecurrenceData(formattedData);
        }
    }, [value]);

    const handleInputClick = () => {
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
    };

    const handleConfirmModal = (data) => {
        setRecurrenceInitial(data)
        const formattedData = formatRecurrenceData(data);
        setRecurrenceData(formattedData);
        onChange(data);
        handleCloseModal();
    };

    return (
        <div>
            <label>{label}</label>
            {required && (
                <span className="required"> *</span>
            )}
            <InputGroup className='input-group'>
                <Input
                    onClick={handleInputClick}
                    value={recurrenceData}
                    placeholder="Clique para configurar recorrência"
                    className="input-with-icon"
                />
                <div className="input-group-append" onClick={handleInputClick}>
                    <span className="input-group-text">
                        <FontAwesomeIcon className='icon' icon={faEdit} />
                    </span>
                </div>
            </InputGroup>
            <CustomModal
                show={modalOpen}
                showButtons={false}
                handleClose={() => setModalOpen(false)}
                title="Personalizar frequência"
                content={<RecurrenceEvent initialRecurrence={recurrenceInitial}  onConfirm={handleConfirmModal} onClose={handleCloseModal} />}
            />
            {error && (
                <span
                    className="error invalid-feedback is-invalid">
                    {error}
                </span>
            )}
        </div>
    );
};

export default RecurrenceInput;